<template>
  <div class="grupo-pendencias">
    <div class="card card-custom mb-6">
      <div class="card-header border-0 pt-6">
        <div class="card-title">
          <div>
            <h3 class="card-label mb-1">Central de pendências</h3>
            <span class="text-muted font-size-sm">
              O que precisa de ação nas empresas do grupo.
            </span>
          </div>
        </div>
        <div class="card-toolbar">
          <router-link
            :to="{ name: 'grupoEmpresa' }"
            class="btn btn-sm btn-light-primary"
          >
            <i class="fas fa-arrow-left mr-1"></i>
            Voltar ao grupo
          </router-link>
        </div>
      </div>

      <div class="card-body pt-4">
        <div v-if="carregandoInicial" class="text-center py-10">
          <span class="spinner spinner-primary"></span>
        </div>

        <template v-else-if="grupo">
          <b-form @submit.prevent="carregarPendencias">
            <div class="row align-items-end">
              <b-form-group
                class="col-md-3"
                label="Vencimentos até"
                label-for="pendencias-vencimento"
              >
                <b-form-select
                  id="pendencias-vencimento"
                  v-model="filtros.dias_vencimento"
                  :options="opcoesDiasVencimento"
                />
              </b-form-group>
              <b-form-group
                class="col-md-3"
                label="Certificados até"
                label-for="pendencias-certificado"
              >
                <b-form-select
                  id="pendencias-certificado"
                  v-model="filtros.dias_certificado"
                  :options="opcoesDiasCertificado"
                />
              </b-form-group>
              <b-form-group
                class="col-md-3"
                label="Sem movimento há"
                label-for="pendencias-movimento"
              >
                <b-form-select
                  id="pendencias-movimento"
                  v-model="filtros.dias_sem_movimento"
                  :options="opcoesDiasSemMovimento"
                />
              </b-form-group>
              <b-form-group
                class="col-md-3"
                label="Ação"
                label-class="invisible"
              >
                <button
                  type="submit"
                  class="btn btn-primary btn-block d-flex align-items-center justify-content-center"
                  :disabled="carregando"
                  data-testid="atualizar-pendencias"
                >
                  <span
                    v-if="carregando"
                    class="spinner spinner-sm spinner-light mr-2"
                  ></span>
                  Atualizar central
                </button>
              </b-form-group>
            </div>
          </b-form>

          <div v-if="carregando" class="text-center py-10">
            <span class="spinner spinner-primary"></span>
          </div>

          <template v-else-if="central">
            <div class="row">
              <div
                v-for="card in cards"
                :key="card.key"
                class="col-sm-6 col-xl-3 mb-5"
              >
                <div class="card card-custom h-100 border">
                  <div class="card-body p-5">
                    <span class="text-muted font-weight-bold d-block mb-2">
                      {{ card.label }}
                    </span>
                    <strong class="font-size-h2" :class="card.className">
                      {{ card.valor }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-custom border mt-2">
              <div class="card-body">
                <div class="row align-items-end mb-2">
                  <b-form-group
                    class="col-lg-4"
                    label="Buscar empresa ou pendência"
                    label-for="pendencias-busca"
                  >
                    <b-form-input
                      id="pendencias-busca"
                      v-model.trim="filtrosLocais.busca"
                      placeholder="Digite para buscar"
                    />
                  </b-form-group>
                  <b-form-group
                    class="col-lg-3"
                    label="Prioridade"
                    label-for="pendencias-prioridade"
                  >
                    <b-form-select
                      id="pendencias-prioridade"
                      v-model="filtrosLocais.severidade"
                      :options="opcoesSeveridade"
                    />
                  </b-form-group>
                  <b-form-group
                    class="col-lg-3"
                    label="Área"
                    label-for="pendencias-categoria"
                  >
                    <b-form-select
                      id="pendencias-categoria"
                      v-model="filtrosLocais.categoria"
                      :options="opcoesCategoria"
                    />
                  </b-form-group>
                  <b-form-group
                    class="col-lg-2"
                    label="Ação"
                    label-class="invisible"
                  >
                    <button
                      type="button"
                      class="btn btn-light btn-block"
                      @click="limparFiltrosLocais"
                    >
                      Limpar filtros
                    </button>
                  </b-form-group>
                </div>

                <div v-if="pendenciasFiltradas.length" class="table-responsive">
                  <table class="table table-vertical-center mb-0">
                    <thead>
                      <tr>
                        <th>Prioridade</th>
                        <th>Empresa</th>
                        <th>Pendência</th>
                        <th>Referência</th>
                        <th class="text-right">Valor</th>
                        <th class="text-right">Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="pendencia in pendenciasFiltradas"
                        :key="pendencia.id"
                      >
                        <td>
                          <span
                            class="label label-inline"
                            :class="classeSeveridade(pendencia.severidade)"
                          >
                            {{ labelSeveridade(pendencia.severidade) }}
                          </span>
                        </td>
                        <td>
                          <strong class="d-block">
                            {{ nomeEmpresa(pendencia.empresa) }}
                          </strong>
                          <small class="text-muted">
                            {{ pendencia.empresa && pendencia.empresa.tipo }}
                          </small>
                        </td>
                        <td>
                          <strong class="d-block">
                            {{ pendencia.titulo }}
                          </strong>
                          <small class="text-muted">
                            {{ pendencia.descricao }}
                          </small>
                        </td>
                        <td class="text-nowrap">
                          {{ formatarData(pendencia.data_referencia) }}
                        </td>
                        <td class="text-right text-nowrap">
                          {{ formatarValor(pendencia.valor) }}
                        </td>
                        <td class="text-right text-nowrap">
                          <button
                            type="button"
                            class="btn btn-sm btn-light-primary"
                            :disabled="
                              trocandoEmpresa ||
                              empresaAtualId === Number(pendencia.id_empresa)
                            "
                            @click="acessarEmpresa(pendencia)"
                          >
                            <span
                              v-if="
                                trocandoEmpresaId ===
                                Number(pendencia.id_empresa)
                              "
                              class="spinner spinner-sm spinner-primary mr-2"
                            ></span>
                            {{
                              empresaAtualId === Number(pendencia.id_empresa)
                                ? "Empresa atual"
                                : "Acessar empresa"
                            }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else class="alert alert-light-success mb-0">
                  Nenhuma pendência encontrada para os filtros selecionados.
                </div>
              </div>
            </div>
          </template>
        </template>

        <div v-else class="alert alert-light-warning mb-0">
          Configure um grupo empresarial antes de consultar as pendências.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SELECT_EMPRESA } from "@/core/services/store/auth.module";

const opcoesDias = (valores) =>
  valores.map((dias) => ({
    value: dias,
    text: `${dias} ${dias === 1 ? "dia" : "dias"}`,
  }));

export default {
  name: "GrupoEmpresaPendencias",
  data() {
    return {
      carregandoInicial: true,
      carregando: false,
      trocandoEmpresa: false,
      trocandoEmpresaId: null,
      grupo: null,
      central: null,
      filtros: {
        dias_vencimento: 7,
        dias_certificado: 30,
        dias_sem_movimento: 30,
      },
      filtrosLocais: {
        busca: "",
        severidade: "",
        categoria: "",
      },
      opcoesDiasVencimento: opcoesDias([3, 7, 15, 30]),
      opcoesDiasCertificado: opcoesDias([15, 30, 60, 90]),
      opcoesDiasSemMovimento: opcoesDias([15, 30, 60, 90]),
      opcoesSeveridade: [
        { value: "", text: "Todas" },
        { value: "CRITICA", text: "Crítica" },
        { value: "ATENCAO", text: "Atenção" },
      ],
      opcoesCategoria: [
        { value: "", text: "Todas" },
        { value: "FINANCEIRO", text: "Financeiro" },
        { value: "FISCAL", text: "Fiscal" },
        { value: "ESTOQUE", text: "Estoque" },
        { value: "OPERACIONAL", text: "Operacional" },
      ],
    };
  },
  computed: {
    ...mapGetters(["empresaContexto"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    cards() {
      const totais = this.central?.totais || {};
      return [
        {
          key: "criticas",
          label: "Pendências críticas",
          valor: Number(totais.criticas || 0),
          className: "text-danger",
        },
        {
          key: "atencao",
          label: "Precisam de atenção",
          valor: Number(totais.atencao || 0),
          className: "text-warning",
        },
        {
          key: "empresas",
          label: "Empresas afetadas",
          valor: Number(totais.empresas_afetadas || 0),
          className: "text-primary",
        },
        {
          key: "total",
          label: "Total de pendências",
          valor: Number(totais.pendencias || 0),
          className: "text-dark",
        },
      ];
    },
    pendenciasFiltradas() {
      const termo = this.normalizarTexto(this.filtrosLocais.busca);

      return (this.central?.pendencias || []).filter((pendencia) => {
        if (
          this.filtrosLocais.severidade &&
          pendencia.severidade !== this.filtrosLocais.severidade
        ) {
          return false;
        }
        if (
          this.filtrosLocais.categoria &&
          pendencia.categoria !== this.filtrosLocais.categoria
        ) {
          return false;
        }
        if (!termo) return true;

        return this.normalizarTexto(
          `${this.nomeEmpresa(pendencia.empresa)} ${pendencia.titulo} ${
            pendencia.descricao
          }`
        ).includes(termo);
      });
    },
  },
  methods: {
    normalizarTexto(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa || ""}`
      );
    },
    labelSeveridade(severidade) {
      return severidade === "CRITICA" ? "Crítica" : "Atenção";
    },
    classeSeveridade(severidade) {
      return severidade === "CRITICA"
        ? "label-light-danger"
        : "label-light-warning";
    },
    formatarData(valor) {
      if (!valor) return "—";
      const [ano, mes, dia] = valor.split("-").map(Number);
      return new Intl.DateTimeFormat("pt-BR").format(
        new Date(ano, mes - 1, dia)
      );
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined) return "—";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor));
    },
    limparFiltrosLocais() {
      this.filtrosLocais = {
        busca: "",
        severidade: "",
        categoria: "",
      };
    },
    async carregarInicial() {
      this.carregandoInicial = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.grupo) {
          await this.carregarPendencias();
        }
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarPendencias() {
      if (!this.grupo?.id_grupo_empresa) return;
      this.carregando = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/pendencias`,
          { params: { ...this.filtros } }
        );
        this.central = data?.data || null;
      } finally {
        this.carregando = false;
      }
    },
    async acessarEmpresa(pendencia) {
      const idEmpresa = Number(pendencia.id_empresa);
      if (
        this.trocandoEmpresa ||
        !idEmpresa ||
        idEmpresa === this.empresaAtualId
      ) {
        return;
      }

      this.trocandoEmpresa = true;
      this.trocandoEmpresaId = idEmpresa;

      try {
        await this.$store.dispatch(SELECT_EMPRESA, {
          id_empresa: idEmpresa,
        });
        this.$toast.success(
          `Empresa alterada para ${this.nomeEmpresa(pendencia.empresa)}.`
        );
        await this.redirecionarDashboard();
      } finally {
        this.trocandoEmpresa = false;
        this.trocandoEmpresaId = null;
      }
    },
    async redirecionarDashboard() {
      await this.$router.replace({ name: "dashboard" });
      window.location.reload();
    },
  },
  mounted() {
    this.carregarInicial();
  },
};
</script>

<style scoped>
.grupo-pendencias .table td,
.grupo-pendencias .table th {
  vertical-align: middle;
}
</style>
